import { render } from "./set.vue?vue&type=template&id=39a2f218&scoped=true&ts=true"
import script from "./set.vue?vue&type=script&lang=ts"
export * from "./set.vue?vue&type=script&lang=ts"

import "./set.vue?vue&type=style&index=0&id=39a2f218&lang=scss&scoped=true"

import exportComponent from "E:\\sunjibo\\upstream_space\\code\\shenzhou\\medical-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a2f218"]])

export default __exports__